// extracted by mini-css-extract-plugin
export var actionButton = "_dg-0";
export var attachmentLine = "_dg-1";
export var fileInput = "_dg-2";
export var fileUploadWrapper = "_dg-4";
export var footer = "_dg-3";
export var modalContent = "_dg-5";
export var paperclip = "_dg-6";
export var quillEditor = "_dg-7";